export const newRelic = ()=>{
if(!process.env.REACT_APP_EASYEAT_ENABLE_NEW_RELIC) return;
const script =document.createElement('script');
script.src=process.env.REACT_APP_Media_Root_Path_URL + '/user-app/new-relic/newrelic.js';
script.defer = true;
document.head.appendChild(script);
}